export default __webpack_public_path__ + "static/media/rebelai-icon.dfd14455.png";